// extracted by mini-css-extract-plugin
export default {"calendar":"src-components-common-DatePicker-styles-Calendar__calendar--nYnch"};